import React, { ReactElement, useEffect, useState, useCallback } from 'react';
import { List,
  ListItem, ListItemText, Paper,
  Skeleton, Switch,
} from '@mui/material';
import api from '../../services/api';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';

import Box from "@mui/material/Box";

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};

export const RequiredFields = ({
  schema,
  values,
  onChange,
}: {
  schema: any;
  values: any;
  onChange?: (value: any, column: string) => void;
}): ReactElement => {
  const [properties, setProperties] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchColumns = useCallback(() => {
    setLoading(true);
    const searchParams = new URLSearchParams({
      service_provider: values?.id,
    });

    api.get(`/service-providers/${values?.id}/required-fields`, searchParams).then((res: any) => {
      setProperties(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchColumns();
  }, []);

  const handleChangeCost = (column: string, value: any) => {
    api.patch(`/service-providers/${values?.id}/required-fields`, {
      column: column,
      value: value,
    }).then((res: any) => {

    });
  }

  return (
    <>
      {loading ? (
        <>
          <Skeleton variant="rectangular" width={'100%'} height={30} />
          <Skeleton
            variant="rectangular"
            width={'100%'}
            height={100}
            sx={{
              marginTop: '10px',
            }}
          />
        </>
      ) : (
        <>
          <Box component={Paper}>
            <List dense={false}>
              {properties && (
                <>
                  {properties.map((item: any) => {
                    return (<>
                      <ListItem
                        sx={{
                          paddingRight: '100px'
                        }}
                        secondaryAction={
                          <>
                            <Switch
                              defaultChecked={item?.value}
                              onChange={(event, checked) => {
                                handleChangeCost(item.column, checked);
                              }}
                              sx={{
                                marginLeft: '10px'
                              }}
                            />
                          </>
                        }
                      >
                        <ListItemText
                          primary={item?.name}
                          secondary={item?.column}
                        />
                      </ListItem>
                    </>);
                  })}
                </>
              )}

            </List>
          </Box>
        </>
      )}

    </>
  );
};
